import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStatePmsConnection = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1412.32 307.89",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{fill:none;stroke:#e6e6e6;stroke-width:1.5px;}.c,.d{stroke-miterlimit:10;}.e{fill:#002f75;}.f{fill:#ebf3ff;}.g{fill:#fafcff;}.h,.d{fill:#fff;}.i{fill:#fff1d6;}.j{fill:#9ec5ff;}.k{fill:#bd0f0f;}.l{fill:#c5f6da;}.m{fill:#08873f;}.n{fill:#0c6734;}.d{stroke:#0c6734;stroke-width:2.39px;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("rect", {
				className: "g",
				width: 1412.41,
				height: 307.89
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("rect", {
						className: "f",
						x: 25,
						y: 82.03,
						width: 380.49,
						height: 180.61
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M38.87,45.24H391.62c7.66,0,13.87,6.22,13.87,13.87v22.92H25v-22.92c0-7.66,6.22-13.87,13.87-13.87Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("circle", {
							className: "l",
							cx: 47.22,
							cy: 63.64,
							r: 8.51
						}),
						/* @__PURE__ */ _jsx("circle", {
							className: "i",
							cx: 72.21,
							cy: 63.64,
							r: 8.51
						}),
						/* @__PURE__ */ _jsx("circle", {
							className: "k",
							cx: 97.19,
							cy: 63.64,
							r: 8.51
						})
					] }),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("rect", {
							className: "h",
							x: 56.53,
							y: 99.31,
							width: 331.6,
							height: 144.15
						}),
						/* @__PURE__ */ _jsx("line", {
							className: "c",
							x1: 388.12,
							y1: 195.64,
							x2: 56.53,
							y2: 195.64
						}),
						/* @__PURE__ */ _jsx("line", {
							className: "c",
							x1: 388.12,
							y1: 147.82,
							x2: 56.53,
							y2: 147.82
						}),
						/* @__PURE__ */ _jsx("line", {
							className: "c",
							x1: 189.17,
							y1: 99.31,
							x2: 189.17,
							y2: 243.46
						}),
						/* @__PURE__ */ _jsx("line", {
							className: "c",
							x1: 122.85,
							y1: 99.31,
							x2: 122.85,
							y2: 243.46
						}),
						/* @__PURE__ */ _jsx("line", {
							className: "c",
							x1: 255.49,
							y1: 99.31,
							x2: 255.49,
							y2: 243.46
						}),
						/* @__PURE__ */ _jsx("line", {
							className: "c",
							x1: 321.8,
							y1: 99.31,
							x2: 321.8,
							y2: 243.46
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "e",
							x: 123.59,
							y: 99.28,
							width: 64.95,
							height: 47.65
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "e",
							x: 322.63,
							y: 148.53,
							width: 65.49,
							height: 46.4
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "e",
							x: 190.08,
							y: 196.36,
							width: 64.62,
							height: 47.1
						})
					] }),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
						className: "m",
						x: 421.64,
						y: 82.46,
						width: 168,
						height: 43.42,
						rx: 4.78,
						ry: 4.78
					}), /* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M456.49,97.37v2.28h-7.12v3.21h6.25v2.26h-6.25v3.78h7.12v2.28h-9.64v-13.8h9.64Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M467.18,104.09v2.18h-5.7v-2.18h5.7Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M473.2,109.85c-.78-.95-1.17-2.26-1.17-3.74s.39-2.8,1.19-3.74c.72-.86,1.93-1.6,3.6-1.6,2.47,0,4.26,1.52,4.38,3.82h-2.36c-.1-1.09-.8-1.71-1.96-1.71-.8,0-1.32,.29-1.65,.66-.6,.66-.72,1.62-.72,2.57s.12,1.91,.72,2.55c.35,.37,.86,.68,1.65,.68,1.15,0,1.87-.66,1.96-1.69h2.36c-.12,2.26-1.99,3.8-4.38,3.8-1.67,0-2.92-.72-3.62-1.6Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M484.09,109.91c-.82-.91-1.29-2.02-1.29-3.8s.47-2.88,1.29-3.8c.72-.82,1.93-1.54,3.64-1.54s2.92,.72,3.64,1.54c.82,.91,1.29,2.02,1.29,3.8s-.47,2.88-1.29,3.8c-.72,.82-1.93,1.54-3.64,1.54s-2.92-.72-3.64-1.54Zm5.3-1.23c.64-.64,.8-1.58,.8-2.57s-.16-1.93-.8-2.57c-.35-.35-.9-.64-1.65-.64s-1.3,.29-1.65,.64c-.64,.64-.8,1.58-.8,2.57s.16,1.93,.8,2.57c.35,.35,.89,.64,1.65,.64s1.3-.29,1.65-.64Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M494.94,101.05h2.12l.12,1.32c.6-1.09,1.85-1.6,3.02-1.6,2.16,0,3.48,1.5,3.48,3.62v6.77h-2.43v-6.21c0-1.19-.56-1.93-1.69-1.93-1.52,0-2.18,1.34-2.18,2.92v5.22h-2.43v-10.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M507.38,103.06h-1.95v-2.01h1.95v-.93c0-1.87,1.26-3.23,3.44-3.23,.7,0,.99,.06,1.65,.21v1.97c-.27-.08-.64-.17-1.17-.17-1.01,0-1.5,.47-1.5,1.38v.78h2.51v2.01h-2.51v8.12h-2.43v-8.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M516.65,97.1v2.51h-2.63v-2.51h2.63Zm-.08,3.95v10.12h-2.47v-10.12h2.47Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M519.42,101.05h2.12l.16,1.67c.47-1.28,1.67-1.81,2.86-1.81,.25,0,.51,.02,.76,.06v2.34c-.19-.06-.49-.1-.78-.1-1.81,0-2.67,1.17-2.67,3.06v4.91h-2.45v-10.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M527.15,101.05h2.12l.1,1.34c.56-.95,1.54-1.62,2.88-1.62,1.42,0,2.37,.64,2.88,1.65,.6-1.05,1.69-1.65,3.06-1.65,2.16,0,3.29,1.44,3.29,3.54v6.85h-2.41v-6.27c0-1.25-.43-2-1.58-2-1.34,0-1.97,1.19-1.97,2.63v5.65h-2.39v-6.27c0-1.25-.43-2-1.58-2-1.34,0-1.99,1.19-1.99,2.63v5.65h-2.41v-10.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M545.22,110.2c-1.03-.97-1.58-2.43-1.58-4.09s.55-3.08,1.56-4.05c.78-.76,1.83-1.28,3.23-1.28,2.92,0,4.67,2.04,4.67,5.06,0,.39-.02,.74-.06,.97h-6.97c0,1.38,.9,2.71,2.43,2.71,1.11,0,1.87-.56,2.04-1.36h2.28c-.29,1.99-2.1,3.29-4.28,3.29-1.44,0-2.51-.49-3.33-1.25Zm5.45-5.16c0-1.5-.88-2.34-2.18-2.34s-2.3,.95-2.39,2.34h4.57Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M556.5,110.46c-1.17-1.01-1.73-2.67-1.73-4.32s.53-3.25,1.52-4.21c.76-.74,1.79-1.15,3.04-1.15,1.46,0,2.32,.64,2.67,1.25v-4.94h2.43v14.09h-2.12l-.14-1.44c-.39,1.15-1.65,1.71-2.9,1.71-1.11,0-2.06-.39-2.76-.99Zm4.81-1.75c.58-.64,.8-1.56,.8-2.61s-.2-1.89-.76-2.55c-.39-.47-.94-.72-1.68-.72s-1.3,.27-1.69,.76c-.55,.68-.74,1.54-.74,2.51s.21,1.95,.8,2.59c.39,.43,.91,.7,1.63,.7s1.27-.27,1.64-.68Z"
						})
					] })] }),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
						className: "m",
						x: 421.64,
						y: 145.93,
						width: 168,
						height: 43.42,
						rx: 4.78,
						ry: 4.78
					}), /* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M442.37,162.63v2.34h-6.76v3.19h6v2.3h-6v5h-2.79v-12.83h9.55Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M447.76,162.63v12.83h-2.81v-12.83h2.81Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M457.38,162.63c2.81,0,4.73,1.56,4.73,4.06,0,1.65-.87,3.06-2.48,3.66l2.43,5.11h-3.06l-2.12-4.69h-2.79v4.69h-2.81v-12.83h6.09Zm1.94,4.06c0-.83-.65-1.81-2.08-1.81h-3.17v3.59h3.21c1.36,0,2.03-.72,2.03-1.79Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M478.99,175.46h-2.7v-9.19l-3.33,9.01h-2.03l-3.3-9.15v9.33h-2.7v-12.83h3.77l3.35,8.93,3.37-8.93h3.57v12.83Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M487.23,173.32c-.78-.95-1.17-2.26-1.17-3.74s.39-2.8,1.19-3.74c.72-.86,1.93-1.6,3.6-1.6,2.47,0,4.26,1.52,4.38,3.82h-2.36c-.1-1.09-.8-1.71-1.96-1.71-.8,0-1.32,.29-1.65,.66-.6,.66-.72,1.62-.72,2.57s.12,1.91,.72,2.55c.35,.37,.86,.68,1.65,.68,1.15,0,1.87-.66,1.96-1.69h2.36c-.12,2.26-1.99,3.8-4.38,3.8-1.67,0-2.92-.72-3.62-1.6Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M498.11,173.38c-.82-.91-1.29-2.02-1.29-3.8s.47-2.88,1.29-3.79c.72-.82,1.93-1.54,3.64-1.54s2.92,.72,3.64,1.54c.82,.91,1.29,2.02,1.29,3.79s-.47,2.88-1.29,3.8c-.72,.82-1.93,1.54-3.64,1.54s-2.92-.72-3.64-1.54Zm5.3-1.23c.64-.64,.8-1.58,.8-2.57s-.16-1.93-.8-2.57c-.35-.35-.9-.64-1.65-.64s-1.3,.29-1.65,.64c-.64,.64-.8,1.58-.8,2.57s.16,1.93,.8,2.57c.35,.35,.89,.64,1.65,.64s1.3-.29,1.65-.64Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M508.96,164.52h2.12l.12,1.32c.6-1.09,1.85-1.6,3.02-1.6,2.16,0,3.48,1.5,3.48,3.62v6.77h-2.43v-6.21c0-1.19-.56-1.93-1.69-1.93-1.52,0-2.18,1.34-2.18,2.92v5.22h-2.43v-10.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M521.41,166.53h-1.95v-2.01h1.95v-.93c0-1.87,1.26-3.23,3.44-3.23,.7,0,.99,.06,1.65,.21v1.96c-.27-.08-.64-.17-1.17-.17-1.01,0-1.5,.47-1.5,1.38v.78h2.51v2.01h-2.51v8.12h-2.43v-8.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M530.68,160.57v2.51h-2.63v-2.51h2.63Zm-.08,3.95v10.12h-2.47v-10.12h2.47Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M533.45,164.52h2.12l.16,1.68c.47-1.29,1.67-1.81,2.86-1.81,.25,0,.51,.02,.76,.06v2.34c-.19-.06-.49-.1-.78-.1-1.81,0-2.67,1.17-2.67,3.06v4.91h-2.45v-10.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M541.18,164.52h2.12l.1,1.34c.56-.95,1.54-1.62,2.88-1.62,1.42,0,2.37,.64,2.88,1.65,.6-1.05,1.69-1.65,3.06-1.65,2.16,0,3.29,1.44,3.29,3.54v6.85h-2.41v-6.27c0-1.25-.43-2-1.58-2-1.34,0-1.97,1.19-1.97,2.63v5.65h-2.39v-6.27c0-1.25-.43-2-1.58-2-1.34,0-1.99,1.19-1.99,2.63v5.65h-2.41v-10.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M559.25,173.67c-1.03-.97-1.58-2.43-1.58-4.09s.55-3.08,1.56-4.05c.78-.76,1.83-1.29,3.23-1.29,2.92,0,4.67,2.04,4.67,5.06,0,.39-.02,.74-.06,.97h-6.97c0,1.38,.9,2.7,2.43,2.7,1.11,0,1.87-.56,2.04-1.36h2.28c-.29,1.99-2.1,3.29-4.28,3.29-1.44,0-2.51-.49-3.33-1.25Zm5.45-5.16c0-1.5-.88-2.34-2.18-2.34s-2.3,.95-2.39,2.34h4.57Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M570.53,173.92c-1.17-1.01-1.73-2.67-1.73-4.32s.53-3.25,1.52-4.21c.76-.74,1.79-1.15,3.04-1.15,1.46,0,2.32,.64,2.67,1.25v-4.94h2.43v14.09h-2.12l-.14-1.44c-.39,1.15-1.65,1.71-2.9,1.71-1.11,0-2.06-.39-2.76-.99Zm4.81-1.75c.58-.64,.8-1.56,.8-2.61s-.2-1.89-.76-2.55c-.39-.47-.94-.72-1.68-.72s-1.3,.27-1.69,.76c-.55,.68-.74,1.54-.74,2.51s.21,1.95,.8,2.59c.39,.43,.91,.7,1.63,.7s1.27-.27,1.64-.68Z"
						})
					] })] }),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
						className: "m",
						x: 421.64,
						y: 209.4,
						width: 168,
						height: 43.42,
						rx: 4.78,
						ry: 4.78
					}), /* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M441.56,236.85c-1.48-1.5-1.91-3.39-1.91-5.65s.43-4.13,1.93-5.63c1.09-1.09,2.53-1.54,4.07-1.54,2.98,0,5.2,2.04,5.39,4.95h-2.57c-.12-1.67-1.19-2.67-2.9-2.67-.88,0-1.69,.33-2.24,.91-.91,.97-1.13,2.22-1.13,3.97s.21,3,1.13,3.99c.54,.58,1.3,.91,2.24,.91,1.62,0,2.71-.97,2.9-2.63h2.57c-.31,3.02-2.57,4.91-5.39,4.91-1.58,0-3.02-.47-4.09-1.54Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M452.47,235.21c0-1.85,1.36-3.08,3.62-3.23l2.78-.19v-.58c0-.95-.51-1.62-1.79-1.62-1.19,0-1.79,.52-1.85,1.46h-2.35c0-1.93,1.73-3.33,4.24-3.33s4.13,1.21,4.13,3.82v4.07c0,.47,.21,.64,.62,.64,.12,0,.23-.02,.31-.04v1.79c-.31,.17-.66,.27-1.21,.27-1.05,0-1.69-.6-1.85-1.48-.47,.82-1.56,1.6-3,1.6-2.41,0-3.66-1.52-3.66-3.17Zm6.4-1.19v-.45l-2.34,.17c-.97,.08-1.69,.45-1.69,1.36,0,.78,.6,1.32,1.62,1.32,1.65,0,2.41-1.09,2.41-2.41Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M464.05,235.5v-11.48h2.45v11.08c0,.58,.14,.97,.97,.97,.21,0,.27-.02,.41-.02v2.04c-.45,.1-.62,.14-1.07,.14-1.65,0-2.77-.8-2.77-2.73Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M469.8,235.5v-11.48h2.45v11.08c0,.58,.14,.97,.97,.97,.21,0,.27-.02,.41-.02v2.04c-.45,.1-.62,.14-1.07,.14-1.65,0-2.77-.8-2.77-2.73Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M480.4,236.79c-.78-.95-1.17-2.26-1.17-3.74s.39-2.8,1.19-3.74c.72-.86,1.93-1.6,3.6-1.6,2.47,0,4.26,1.52,4.38,3.82h-2.36c-.1-1.09-.8-1.71-1.96-1.71-.8,0-1.32,.29-1.65,.66-.6,.66-.72,1.61-.72,2.57s.12,1.91,.72,2.55c.35,.37,.86,.68,1.65,.68,1.15,0,1.87-.66,1.96-1.69h2.36c-.12,2.26-1.99,3.8-4.38,3.8-1.67,0-2.92-.72-3.62-1.6Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M491.29,236.85c-.82-.91-1.29-2.03-1.29-3.8s.47-2.88,1.29-3.8c.72-.82,1.93-1.54,3.64-1.54s2.92,.72,3.64,1.54c.82,.91,1.29,2.02,1.29,3.8s-.47,2.88-1.29,3.8c-.72,.82-1.93,1.54-3.64,1.54s-2.92-.72-3.64-1.54Zm5.3-1.23c.64-.64,.8-1.58,.8-2.57s-.16-1.93-.8-2.57c-.35-.35-.9-.64-1.65-.64s-1.3,.29-1.65,.64c-.64,.64-.8,1.58-.8,2.57s.16,1.93,.8,2.57c.35,.35,.89,.64,1.65,.64s1.3-.29,1.65-.64Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M502.13,227.99h2.12l.12,1.32c.6-1.09,1.85-1.6,3.02-1.6,2.16,0,3.48,1.5,3.48,3.62v6.77h-2.43v-6.21c0-1.19-.56-1.93-1.69-1.93-1.52,0-2.18,1.34-2.18,2.92v5.22h-2.43v-10.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M514.58,230h-1.95v-2h1.95v-.93c0-1.87,1.26-3.23,3.44-3.23,.7,0,.99,.06,1.65,.21v1.97c-.27-.08-.64-.17-1.17-.17-1.01,0-1.5,.47-1.5,1.38v.78h2.51v2h-2.51v8.12h-2.43v-8.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M523.85,224.04v2.51h-2.63v-2.51h2.63Zm-.08,3.95v10.12h-2.47v-10.12h2.47Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M526.62,227.99h2.12l.16,1.67c.47-1.28,1.67-1.81,2.86-1.81,.25,0,.51,.02,.76,.06v2.34c-.19-.06-.49-.1-.78-.1-1.81,0-2.67,1.17-2.67,3.06v4.91h-2.45v-10.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M534.35,227.99h2.12l.1,1.34c.56-.95,1.54-1.61,2.88-1.61,1.42,0,2.37,.64,2.88,1.65,.6-1.05,1.69-1.65,3.06-1.65,2.16,0,3.29,1.44,3.29,3.54v6.85h-2.41v-6.27c0-1.25-.43-2-1.58-2-1.34,0-1.97,1.19-1.97,2.63v5.65h-2.39v-6.27c0-1.25-.43-2-1.58-2-1.34,0-1.99,1.19-1.99,2.63v5.65h-2.41v-10.12Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M552.42,237.14c-1.03-.97-1.58-2.43-1.58-4.09s.55-3.08,1.56-4.05c.78-.76,1.83-1.28,3.23-1.28,2.92,0,4.67,2.04,4.67,5.06,0,.39-.02,.74-.06,.97h-6.97c0,1.38,.9,2.71,2.43,2.71,1.11,0,1.87-.56,2.04-1.36h2.28c-.29,1.99-2.1,3.29-4.28,3.29-1.44,0-2.51-.49-3.33-1.25Zm5.45-5.16c0-1.5-.88-2.34-2.18-2.34s-2.3,.95-2.39,2.34h4.57Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "f",
							d: "M563.7,237.39c-1.17-1.01-1.73-2.67-1.73-4.32s.53-3.25,1.52-4.21c.76-.74,1.79-1.15,3.04-1.15,1.46,0,2.32,.64,2.67,1.25v-4.95h2.43v14.09h-2.12l-.14-1.44c-.39,1.15-1.65,1.71-2.9,1.71-1.11,0-2.06-.39-2.76-.99Zm4.81-1.75c.58-.64,.8-1.56,.8-2.61s-.2-1.89-.76-2.55c-.39-.47-.94-.72-1.68-.72s-1.3,.27-1.69,.76c-.55,.68-.74,1.54-.74,2.51s.21,1.95,.8,2.59c.39,.43,.91,.7,1.63,.7s1.27-.27,1.64-.68Z"
						})
					] })] })
				] }),
				/* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 854.71,
					y: 81.9,
					width: 380.49,
					height: 180.61
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 854.71,
					y: 81.9,
					width: 380.49,
					height: 59.86,
					rx: 3.04,
					ry: 3.04
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 854.71,
					y: 202.92,
					width: 380.49,
					height: 59.86,
					rx: 3.04,
					ry: 3.04
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M868.58,45.11h352.75c7.66,0,13.87,6.22,13.87,13.87v22.92h-380.49v-22.92c0-7.66,6.22-13.87,13.87-13.87Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "l",
						cx: 876.93,
						cy: 63.5,
						r: 8.51
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "i",
						cx: 901.92,
						cy: 63.5,
						r: 8.51
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "k",
						cx: 926.91,
						cy: 63.5,
						r: 8.51
					})
				] }),
				/* @__PURE__ */ _jsx("rect", {
					className: "d",
					x: 841.69,
					y: 142.79,
					width: 406.54,
					height: 59.86,
					rx: 3.14,
					ry: 3.14
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "g",
						d: "M907.58,111.83c0,5.21-2.17,9.91-5.66,13.24-3.29,3.15-7.75,5.08-12.66,5.08s-9.37-1.93-12.66-5.07c-3.49-3.34-5.66-8.03-5.66-13.25,0-10.12,8.2-18.32,18.32-18.32s18.32,8.2,18.32,18.32Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "j",
						d: "M901.92,125.07c-3.29,3.15-7.75,5.08-12.66,5.08s-9.37-1.93-12.66-5.07c.81-5.26,4.82-9.46,9.98-10.56-2.71-1.07-4.63-3.71-4.63-6.8,0-4.04,3.27-7.31,7.31-7.31s7.31,3.27,7.31,7.31c0,3.1-1.92,5.73-4.64,6.8,5.16,1.1,9.17,5.3,9.98,10.55Z"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "j",
						x: 926.91,
						y: 103.83,
						width: 225.44,
						height: 6.91,
						rx: 3.45,
						ry: 3.45
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "j",
						x: 926.91,
						y: 115.28,
						width: 112.72,
						height: 6.91,
						rx: 3.45,
						ry: 3.45
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "n",
						d: "M907.58,172.72c0,5.21-2.17,9.91-5.66,13.24-3.29,3.15-7.75,5.08-12.66,5.08s-9.37-1.93-12.66-5.07c-3.49-3.34-5.66-8.03-5.66-13.25,0-10.12,8.2-18.32,18.32-18.32s18.32,8.2,18.32,18.32Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "h",
						d: "M901.92,186.29c-3.29,3.15-7.75,5.08-12.66,5.08s-9.37-1.93-12.66-5.07c.81-5.26,4.82-9.46,9.98-10.56-2.71-1.07-4.63-3.71-4.63-6.8,0-4.04,3.27-7.31,7.31-7.31s7.31,3.27,7.31,7.31c0,3.1-1.92,5.73-4.64,6.8,5.16,1.1,9.17,5.3,9.98,10.55Z"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "n",
						x: 926.91,
						y: 164.72,
						width: 225.44,
						height: 6.91,
						rx: 3.45,
						ry: 3.45
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "n",
						x: 926.91,
						y: 176.16,
						width: 112.72,
						height: 6.91,
						rx: 3.45,
						ry: 3.45
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "g",
						d: "M907.58,232.85c0,5.21-2.17,9.91-5.66,13.24-3.29,3.15-7.75,5.08-12.66,5.08s-9.37-1.93-12.66-5.07c-3.49-3.34-5.66-8.03-5.66-13.25,0-10.12,8.2-18.32,18.32-18.32s18.32,8.2,18.32,18.32Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "j",
						d: "M901.92,246.09c-3.29,3.15-7.75,5.08-12.66,5.08s-9.37-1.93-12.66-5.07c.81-5.26,4.82-9.46,9.98-10.56-2.71-1.07-4.63-3.71-4.63-6.8,0-4.04,3.27-7.31,7.31-7.31s7.31,3.27,7.31,7.31c0,3.1-1.92,5.73-4.64,6.8,5.16,1.1,9.17,5.3,9.98,10.55Z"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "j",
						x: 926.91,
						y: 224.85,
						width: 225.44,
						height: 6.91,
						rx: 3.45,
						ry: 3.45
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "j",
						x: 926.91,
						y: 236.29,
						width: 112.72,
						height: 6.91,
						rx: 3.45,
						ry: 3.45
					})
				] }),
				/* @__PURE__ */ _jsx("path", {
					className: "j",
					d: "M1213.43,111.83c0,3.25-1.36,6.19-3.54,8.27-2.05,1.97-4.84,3.17-7.91,3.17s-5.85-1.2-7.91-3.17c-2.18-2.08-3.54-5.02-3.54-8.28,0-6.32,5.12-11.45,11.45-11.45s11.45,5.13,11.45,11.45Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "j",
					d: "M1213.43,233.61c0,3.25-1.36,6.19-3.54,8.27-2.05,1.97-4.84,3.17-7.91,3.17s-5.85-1.2-7.91-3.17c-2.18-2.08-3.54-5.02-3.54-8.28,0-6.32,5.12-11.45,11.45-11.45s11.45,5.13,11.45,11.45Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "n",
					d: "M1213.43,172.34c0,3.25-1.36,6.19-3.54,8.27-2.05,1.97-4.84,3.17-7.91,3.17s-5.85-1.2-7.91-3.17c-2.18-2.08-3.54-5.02-3.54-8.28,0-6.32,5.12-11.45,11.45-11.45s11.45,5.13,11.45,11.45Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "f",
					d: "M1208.67,168.38c.01,.31-.1,.61-.32,.83l-7.77,7.77c-.2,.2-.45,.33-.72,.36-.33,.03-.65-.09-.88-.32l-3.35-3.35c-.22-.22-.34-.52-.32-.83,.01-.31,.16-.6,.4-.8,.43-.36,1.1-.32,1.51,.1l2.52,2.52s.03,.01,.04,0l6.99-6.99c.41-.41,1.07-.45,1.51-.1,.24,.2,.39,.49,.4,.8Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "m",
					x: 1262.79,
					y: 151.01,
					width: 124.53,
					height: 43.42,
					rx: 4.12,
					ry: 4.12
				}), /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M1274.7,179.09c-1.64-1.66-2.12-3.76-2.12-6.27s.48-4.58,2.14-6.25c1.21-1.21,2.81-1.71,4.52-1.71,3.31,0,5.77,2.27,5.99,5.49h-2.85c-.13-1.86-1.32-2.96-3.22-2.96-.97,0-1.88,.37-2.49,1.02-1.02,1.08-1.25,2.46-1.25,4.41s.24,3.33,1.25,4.43c.61,.65,1.45,1.02,2.49,1.02,1.79,0,3-1.08,3.22-2.92h2.85c-.35,3.35-2.85,5.45-5.99,5.45-1.75,0-3.35-.52-4.54-1.71Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M1288.36,179.09c-.91-1.02-1.43-2.25-1.43-4.21s.52-3.2,1.43-4.21c.8-.91,2.14-1.71,4.04-1.71s3.24,.8,4.04,1.71c.91,1.02,1.43,2.25,1.43,4.21s-.52,3.2-1.43,4.21c-.8,.91-2.14,1.71-4.04,1.71s-3.24-.8-4.04-1.71Zm5.88-1.36c.71-.71,.88-1.75,.88-2.85s-.17-2.14-.88-2.85c-.39-.39-.99-.71-1.84-.71s-1.45,.32-1.84,.71c-.71,.71-.89,1.75-.89,2.85s.17,2.14,.89,2.85c.39,.39,.99,.71,1.84,.71s1.45-.32,1.84-.71Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M1300.4,169.26h2.36l.13,1.47c.67-1.21,2.05-1.77,3.35-1.77,2.4,0,3.87,1.66,3.87,4.02v7.52h-2.7v-6.89c0-1.32-.63-2.14-1.88-2.14-1.69,0-2.42,1.49-2.42,3.24v5.79h-2.7v-11.24Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M1314.22,171.49h-2.16v-2.23h2.16v-1.04c0-2.07,1.4-3.59,3.82-3.59,.78,0,1.1,.06,1.84,.24v2.18c-.3-.09-.71-.19-1.3-.19-1.12,0-1.66,.52-1.66,1.53v.86h2.79v2.23h-2.79v9.01h-2.7v-9.01Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M1324.51,164.87v2.79h-2.92v-2.79h2.92Zm-.09,4.39v11.24h-2.74v-11.24h2.74Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M1327.58,169.26h2.36l.17,1.86c.52-1.43,1.86-2.01,3.18-2.01,.28,0,.56,.02,.84,.06v2.59c-.22-.07-.54-.11-.86-.11-2.01,0-2.96,1.3-2.96,3.39v5.45h-2.72v-11.24Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M1336.16,169.26h2.36l.11,1.49c.63-1.06,1.71-1.79,3.2-1.79,1.58,0,2.64,.71,3.2,1.84,.67-1.17,1.88-1.84,3.39-1.84,2.4,0,3.65,1.6,3.65,3.93v7.61h-2.68v-6.96c0-1.38-.48-2.23-1.75-2.23-1.49,0-2.18,1.32-2.18,2.92v6.27h-2.66v-6.96c0-1.38-.48-2.23-1.75-2.23-1.49,0-2.2,1.32-2.2,2.92v6.27h-2.68v-11.24Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M1356.23,179.42c-1.14-1.08-1.75-2.7-1.75-4.54s.61-3.41,1.73-4.49c.86-.84,2.03-1.43,3.59-1.43,3.24,0,5.19,2.27,5.19,5.62,0,.43-.02,.82-.07,1.08h-7.74c0,1.53,.99,3,2.7,3,1.23,0,2.07-.63,2.27-1.51h2.53c-.33,2.2-2.34,3.65-4.75,3.65-1.6,0-2.79-.54-3.69-1.38Zm6.05-5.73c0-1.66-.97-2.59-2.42-2.59s-2.55,1.06-2.66,2.59h5.08Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M1368.75,179.7c-1.3-1.12-1.92-2.96-1.92-4.8s.58-3.61,1.69-4.67c.84-.82,1.99-1.27,3.37-1.27,1.62,0,2.57,.71,2.96,1.38v-5.49h2.7v15.64h-2.36l-.15-1.6c-.43,1.28-1.84,1.9-3.22,1.9-1.23,0-2.29-.43-3.07-1.1Zm5.34-1.95c.65-.71,.89-1.73,.89-2.89s-.22-2.1-.84-2.83c-.43-.52-1.04-.8-1.86-.8s-1.45,.3-1.88,.84c-.61,.76-.82,1.71-.82,2.79s.24,2.16,.89,2.87c.43,.48,1.02,.78,1.81,.78s1.41-.3,1.82-.76Z"
					})
				] })] }),
				/* @__PURE__ */ _jsx("path", {
					className: "j",
					d: "M752.79,168.09l-30.84-17.8c-.67-.38-1.5,.1-1.5,.87v11.2h-62.06c-.53,0-.96,.43-.96,.96v11.29c0,.53,.43,.96,.96,.96h62.06v11.2c0,.77,.83,1.25,1.5,.87l30.84-17.8c.67-.38,.67-1.35,0-1.73Z"
				})
			]
		})
	]
});
export default SvgEmptyStatePmsConnection;
